import { Button, message, Modal, Typography } from "antd";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { expenses } from "../../actions/expenses/expenses";
import { userReportLinkExp } from "../../actions/reports/reports";
import block from "../../assets/icons/block.png";
import warn from "../../assets/icons/warning.png";
import { apis } from "../../config/APIs";
import endpoint from "../../config/Axios";
import { objectToFormData } from "../../utils";
import BaseCurrency from "../Common/BaseCurrency";
import TableWrap from "../Common/Table/Table";
import "./report.css";

message.config({
  maxCount: 3,
});

const Title = Typography.Title;

const LinkExpenses = (props) => {
  const dispatch = useDispatch();
  const [selectedData, setSelectedData] = React.useState([]);
  const [violations, setViolations] = React.useState([]);
  const [showViolations, setShowViolations] = React.useState(false);
  const expensesResponse = useSelector(
    (state) => state.expenses.expenses || {},
  );

  React.useEffect(() => {
    dispatch(expenses({ added_to_report: false, page: 1 }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const {
    data: { response: { transactions = [] } = {}, total_records = 0 } = {},
  } = expensesResponse;

  const columns = [
    {
      title: "Ex- ID",
      dataIndex: "transaction_number",
      key: "transaction_number",
    },
    {
      title: "Merchant",
      dataIndex: "merchant",
      key: "merchant",
      // render: (text) => <div>{moment(text).format("DD MMM YYYY")}</div>,
    },
    {
      title: "Date and Time",
      dataIndex: "date",
      key: "date",
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      render: (text) => (
        <div>
          <BaseCurrency /> {text}
        </div>
      ),
    },
  ];

  const rowSelection = {
    selectedRowKeys: selectedData,
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedData(selectedRowKeys);
    },
  };

  const handleClearList = () => {
    setSelectedData([]);
  };

  const handleAddExp = () => {
    const payload = {};
    payload.transactions = selectedData;
    payload.report_id = props.report_id;
    dispatch(userReportLinkExp(objectToFormData({ ...payload })));
    setSelectedData([]);
  };

  return (
    <div className="expenses-table">
      {selectedData.length ? (
        <>
          <Button
            type="default"
            ghost
            className="approve-add-btn mb1"
            onClick={() => handleClearList()}
          >
            Clear Selection
          </Button>
          <Button
            onClick={() => {
              endpoint
                .post(
                  apis.validate_expense,
                  {
                    transaction_ids: selectedData,
                  },
                  { skipSuccessMessage: true },
                )
                .then((res) => {
                  let txns = res.data?.response?.transactions || [];
                  let policies = [];
                  txns?.forEach((ele) => {
                    policies = [
                      ...policies,
                      ...ele?.policies?.map(
                        (e) => e.is_blocked && e.errors?.length,
                      ),
                    ];
                  });

                  if (policies?.filter((ele) => ele)?.length) {
                    setShowViolations(true);
                    setViolations(txns);
                  } else {
                    handleAddExp();
                  }
                });
            }}
            className="floatRight ml1 primaryButton"
          >
            Add {selectedData.length > 1 ? selectedData.length : ""} Expenses
          </Button>
        </>
      ) : null}

      <Modal
        title={<Title level={4}>Policy Violation Information</Title>}
        visible={showViolations}
        onCancel={() => {
          setShowViolations(false);
        }}
        footer={[]}
      >
        <div className="violations">
          {violations?.map((ele, idx) => (
            <div className="item">
              {idx + 1}. {ele.transaction_number} -
              {ele.policies?.map((itm) =>
                itm.errors.map((e) => (
                  <span className={itm.is_warning ? "warn" : ""}>
                    <img
                      src={itm.is_warning ? warn : block}
                      alt=""
                      width={12}
                    />{" "}
                    {e}
                  </span>
                )),
              )}
            </div>
          ))}
        </div>
      </Modal>
      <TableWrap
        rowKey="id"
        columns={columns}
        data={transactions}
        className="tableStyled"
        pagination={{
          total: total_records,
          onChange: (pagee) => {
            dispatch(expenses({ added_to_report: false, page: pagee }));
          },
        }}
        rowSelection={{
          type: "checkbox",
          ...rowSelection,
        }}
      />
    </div>
  );
};

export default LinkExpenses;
